import '../scss/style.scss';
import '../js/mail.js'

console.log('Parcel is working. Hurray!');